import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { screenSizes } from '../Literals';

export const volunteerCompanyRegistrationStyles = css`
  --network-accent: #2596c2;
  --network-text: #2c2c2c;
  --network-muted: #5c5c5c;
  --network-border: rgba(34, 36, 38, 0.12);
  --network-surface: #ffffff;
  --network-soft: #f4f8fb;

  width: min(920px, 94vw);
  margin: 2rem auto 3rem;
  padding: 0;
  color: var(--network-text);
  box-sizing: border-box;

  &.editing {
    width: 100%;
    max-width: none;
    margin: 0;
    padding: 0;

    .inner {
      box-shadow: none;
      border: none;
      border-radius: 0;
      padding: 0.5rem 0.25rem 1rem;
    }
  }

  .inner {
    background: var(--network-surface);
    border: 1px solid var(--network-border);
    border-radius: 18px;
    box-shadow: 0 10px 30px rgba(37, 150, 194, 0.08);
    padding: 1.75rem 1.5rem 2rem;
    box-sizing: border-box;

    @media only screen and (min-width: ${screenSizes.tablet}) {
      padding: 2.25rem 2.5rem 2.5rem;
    }
  }

  header {
    text-align: center;
    margin-bottom: 1.5rem;

    h2 {
      margin: 0;
      color: var(--network-accent);
      font-size: clamp(1.6rem, 2.5vw, 2.1rem);
      font-weight: 700;
      line-height: 1.25;
      letter-spacing: -0.02em;
    }

    .header-subtitle {
      margin: 0.65rem auto 0;
      max-width: 42rem;
      color: var(--network-muted);
      font-size: 1rem;
      line-height: 1.5;
    }
  }

  .disclaimer {
    background: var(--network-soft);
    border: 1px solid rgba(37, 150, 194, 0.18);
    border-left: 4px solid var(--network-accent);
    border-radius: 12px;
    padding: 1rem 1.15rem;
    margin: 0 0 1.75rem;

    p {
      margin: 0;
      color: var(--network-muted);
      font-size: 0.95rem;
      line-height: 1.55;
      text-align: left;
      font-style: italic;
    }

    p + p {
      margin-top: 0.75rem;
    }
  }

  .form-section {
    background: var(--network-soft);
    border: 1px solid var(--network-border);
    border-radius: 14px;
    padding: 1.15rem 1rem 1.25rem;
    margin-bottom: 1.25rem;

    @media only screen and (min-width: ${screenSizes.tablet}) {
      padding: 1.35rem 1.35rem 1.5rem;
    }

    &__title {
      margin: 0 0 1rem;
      padding-bottom: 0.65rem;
      border-bottom: 1px solid var(--network-border);
      color: var(--network-text);
      font-size: 1.05rem;
      font-weight: 700;
      letter-spacing: 0.01em;
      text-align: left;
    }

    &__body {
      width: 100%;
    }
  }

  .job-postings__intro {
    margin: 0 0 1rem;
    color: var(--network-muted);
    font-size: 0.95rem;
    line-height: 1.45;
    text-align: left;
  }

  .job-posting {
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    margin-bottom: 1rem;
    padding: 0.95rem 0.95rem 1rem;
    background: var(--network-surface);
    border: 1px solid var(--network-border);
    border-radius: 10px;
    text-align: left;

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.75rem;
      font-weight: 650;
    }

    .ui.input,
    .ui.input > input,
    .Registration__input,
    #transversal,
    textarea {
      width: 100% !important;
      max-width: none !important;
      min-width: 0 !important;
      box-sizing: border-box;
    }

    #transversal {
      margin: 0;
    }

    textarea {
      display: block;
      min-height: 8.5rem;
      margin: 0 !important;
      padding: 0.85rem 1rem !important;
      border: 1px solid rgba(34, 36, 38, 0.15) !important;
      border-radius: 12px !important;
      background: #fff;
      color: rgba(0, 0, 0, 0.87);
      font-family: inherit;
      font-size: 1rem;
      line-height: 1.45;
      resize: vertical;
      box-sizing: border-box;

      &:focus {
        outline: none;
        border-color: var(--network-accent) !important;
        box-shadow: 0 0 0 1px var(--network-accent);
      }
    }
  }

  .Registration__form,
  .network-fields {
    padding: 0;
    text-align: left;
  }

  .lookup-form {
    background: transparent;
    border-radius: 0;
    width: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    .actions__buttons {
      display: flex;
      justify-content: center;
      margin-top: 1rem;
      width: 100%;

      .ui.button {
        margin: 0;
        min-width: 9rem;
      }
    }
  }

  .Registration__input,
  .ui.input.Registration__input,
  .ui.selection.dropdown.Registration__input {
    width: 100% !important;
    display: block !important;
    margin: 0 !important;
  }

  .Registration__input-serviceOffered {
    width: 100%;
  }

  .field-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem 1.25rem;
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
    text-align: left;
    box-sizing: border-box;

    @media only screen and (max-width: ${screenSizes.tablet}) {
      grid-template-columns: 1fr;
      gap: 0.875rem;
      max-width: 100%;
    }

    &--full {
      max-width: none;
    }

    .field-grid__full {
      grid-column: 1 / -1;
    }
  }

  .comunidadMemeber {
    width: 100%;
    max-width: 720px;
    margin: 1rem auto 0;

    .ui.selection.dropdown {
      width: 100% !important;
      min-height: 2.75rem;
    }
  }

  .product-fields {
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .ui.input,
    .ui.input.Registration__input {
      width: 100% !important;
      margin: 0 !important;
    }

    #transversal {
      width: 100%;
    }

    textarea {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 100% !important;
      min-height: 120px;
      margin: 0;
      padding: 0.85rem 1rem;
      border: 1px solid rgba(34, 36, 38, 0.15);
      border-radius: 12px;
      color: rgba(0, 0, 0, 0.87);
      font-size: 1rem;
      line-height: 1.45;
      resize: vertical;
      box-sizing: border-box;

      &:focus {
        outline: none;
        border-color: var(--network-accent);
      }
    }
  }

  .media-fields {
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .media-block__label {
    margin: 0;
    font-weight: 700;
    text-align: left;
  }

  .media-block__hint {
    margin: 0.25rem 0 0.75rem;
    color: var(--network-muted);
    font-size: 0.9rem;
    text-align: left;
  }

  .media-block__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 0.75rem;
  }

  .media-drop {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    width: 100%;
    margin: 0;
    padding: 0.85rem;
    border: 1px dashed rgba(37, 150, 194, 0.55);
    border-radius: 14px;
    background: #fff;
    cursor: pointer;
    box-sizing: border-box;

    &.is-dragover {
      border-color: var(--network-accent);
      background: rgba(37, 150, 194, 0.1);
      box-shadow: inset 0 0 0 2px rgba(37, 150, 194, 0.25);
    }

    &.is-disabled {
      cursor: not-allowed;
      opacity: 0.72;
    }

    .media-tile {
      width: min(160px, 100%);
    }

    .media-grid .media-tile {
      width: auto;
    }
  }

  .media-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 0.75rem;
  }

  .media-tile {
    position: relative;
    aspect-ratio: 1;
    border: 1px dashed rgba(37, 150, 194, 0.45);
    border-radius: 12px;
    background: #fff;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--network-muted);
    font-size: 0.85rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .media-tile__remove {
    position: absolute;
    right: 0.35rem;
    bottom: 0.35rem;
    border: none;
    border-radius: 999px;
    padding: 0.2rem 0.55rem;
    background: rgba(0, 0, 0, 0.72);
    color: #fff;
    font-size: 0.75rem;
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  .actions {
    margin: 1.5rem 0 0;
    padding: 1.35rem 1rem;
    background: var(--network-surface);
    border: 1px solid var(--network-border);
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;

    .published-field {
      width: 100%;
      max-width: 320px;
      text-align: left;

      > p {
        margin: 0 0 0.4rem;
        font-weight: 600;
        font-size: 0.9rem;
        color: #333;
      }

      .ui.selection.dropdown {
        width: 100% !important;
      }
    }

    .actions__buttons {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 0.75rem;
      width: 100%;

      .ui.button {
        margin: 0;
        min-width: 9rem;
      }
    }

    .form-error {
      margin: 0;
      color: #db2828;
      text-align: center;
      font-size: 0.95rem;
      font-weight: 600;
    }
  }

  .success-state {
    text-align: center;
    padding: 2rem 1rem 1.25rem;

    h3 {
      margin: 0 0 0.75rem;
      color: var(--network-accent);
      font-size: 1.75rem;
      font-weight: 700;
    }

    p {
      margin: 0 auto 0.75rem;
      max-width: 36rem;
      color: var(--network-muted);
      font-size: 1.05rem;
      line-height: 1.55;
    }

    .success-state__actions {
      margin-top: 1.5rem;
    }
  }
`;

export const VolunteerCompanyRegistration = styled.div`
  ${volunteerCompanyRegistrationStyles}
`;

export const transversalStyles = css`
  textarea {
    border: 1px solid rgba(34, 36, 38, 0.15);
    border-radius: 8px;
    width: 92%;
    display: block;
    margin: auto;
    color: rgba(0, 0, 0, 0.87);
  }
`;

export const TransversalSection = styled.div`
  ${transversalStyles}
`;

export const ComunidadNetworkSection = styled.section`
  &.comunidad-network {
    background-color: white;
    padding: 20px;
    margin: 35px;
    border-radius: 10px;
    .cards {
      i {
        font-size: 15px;
        margin: 0 5px 5px 0;
      }
      .description {
        font-size: 15px;
      }
    }
  }
`;

export const NetworkCatalogPage = styled.section`
  --catalog-text: #191919;
  --catalog-muted: #666666;
  --catalog-border: #e0e0e0;
  --catalog-surface: #ffffff;
  --catalog-page: #f4f2ee;
  --catalog-accent: #0a66c2;

  width: 100%;
  min-height: 100%;
  background: var(--catalog-page);
  color: var(--catalog-text);
  padding: 1.5rem 1rem 3rem;
  box-sizing: border-box;

  @media only screen and (min-width: ${screenSizes.tablet}) {
    padding: 2rem 1.5rem 3.5rem;
  }

  .catalog-shell {
    width: min(1180px, 100%);
    margin: 0 auto;
  }

  .catalog-header {
    margin-bottom: 1.25rem;

    h1 {
      margin: 0;
      font-size: clamp(1.5rem, 2.4vw, 1.85rem);
      font-weight: 650;
      letter-spacing: -0.02em;
      line-height: 1.25;
      color: var(--catalog-text);
    }

    p {
      margin: 0.4rem 0 0;
      max-width: 40rem;
      color: var(--catalog-muted);
      font-size: 0.95rem;
      line-height: 1.45;
    }
  }

  .catalog-toolbar {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-bottom: 1rem;
    padding: 1rem;
    background: var(--catalog-surface);
    border: 1px solid var(--catalog-border);
    border-radius: 8px;

    @media only screen and (min-width: ${screenSizes.tablet}) {
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      padding: 0.85rem 1rem;
    }
  }

  .catalog-search {
    flex: 0 0 auto;
    width: 100%;
    min-width: 0;

    @media only screen and (min-width: ${screenSizes.tablet}) {
      flex: 1 1 240px;
    }

    .ui.input {
      width: 100%;
    }

    input {
      border-radius: 24px !important;
      border-color: var(--catalog-border) !important;
      background: #f3f2ef !important;
    }
  }

  .catalog-category {
    flex: 0 0 auto;
    width: 100%;
    min-width: 0;

    @media only screen and (min-width: ${screenSizes.tablet}) {
      flex: 1 1 220px;
    }

    .ui.dropdown {
      width: 100%;
      border-radius: 24px !important;
      border-color: var(--catalog-border) !important;
      background: #f3f2ef !important;
      min-height: 2.5rem;
    }
  }

  .catalog-search-button.ui.button {
    margin: 0;
    flex: 0 0 auto;
    border-radius: 24px;
    min-height: 2.5rem;
  }

  .catalog-edit-link-row {
    margin: 0 0 3px 0;
    text-align: right;
  }

  .catalog-edit-link {
    display: inline-block;
    color: var(--catalog-muted);
    font-size: 0.8rem;
    line-height: 1.2;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      color: var(--catalog-text);
    }
  }

  .catalog-count {
    margin: 0;
    color: var(--catalog-muted);
    font-size: 0.875rem;
    white-space: nowrap;
    margin-left: auto;
  }

  .catalog-disclaimer {
    position: relative;
    margin: 0 0 1.25rem;
    padding: 0.85rem 5.5rem 1.75rem 1rem;
    background: var(--catalog-surface);
    border: 1px solid var(--catalog-border);
    border-radius: 8px;

    &__accept {
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
      margin: 0;
      padding: 0.3rem 0.65rem;
      border: 1px solid rgba(34, 36, 38, 0.12);
      border-radius: 4px;
      background: #f3f2ef;
      color: #6b6b6b;
      font-size: 0.75rem;
      font-weight: 500;
      line-height: 1.2;
      cursor: pointer;

      &:hover {
        background: #e8e6e1;
        color: #555;
      }
    }

    &__never {
      position: absolute;
      right: 0.65rem;
      bottom: 0.4rem;
      margin: 0;
      padding: 0;
      border: none;
      background: transparent;
      color: #9a9a9a;
      font-size: 0.7rem;
      font-weight: 400;
      line-height: 1.2;
      text-decoration: underline;
      text-underline-offset: 2px;
      cursor: pointer;

      &:hover {
        color: #6b6b6b;
      }
    }

    &__body {
      p {
        margin: 0;
        color: var(--catalog-muted);
        font-size: 0.8125rem;
        line-height: 1.5;
      }

      p + p {
        margin-top: 0.5rem;
      }
    }
  }

  .catalog-disclaimer-show {
    margin: 0 0 0.35rem;
    padding: 0;
    text-align: right;
    line-height: 1;

    &__link {
      margin: 0;
      padding: 0;
      border: none;
      background: transparent;
      color: #9a9a9a;
      font-size: 0.7rem;
      font-weight: 400;
      line-height: 1.2;
      text-decoration: underline;
      text-underline-offset: 2px;
      cursor: pointer;

      &:hover {
        color: #6b6b6b;
      }
    }
  }

  .catalog-grid {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.75rem;

    @media only screen and (min-width: ${screenSizes.tablet}) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media only screen and (min-width: ${screenSizes.laptop}) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 1rem;
    }

    > li {
      min-width: 0;
    }

    button {
      height: 100%;
      border: 1px solid var(--catalog-border);
      border-radius: 8px;
      border-bottom: 1px solid var(--catalog-border);
      background: var(--catalog-surface);
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

      &:hover {
        background: #fafafa;
        border-color: #d0d0d0;
      }

      &:last-child {
        border-bottom: 1px solid var(--catalog-border);
      }
    }
  }

  .catalog-workspace {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.75rem;
    align-items: start;
    min-height: 28rem;

    @media only screen and (min-width: ${screenSizes.laptop}) {
      grid-template-columns: minmax(280px, 380px) minmax(0, 1fr);
      gap: 0;
      background: var(--catalog-surface);
      border: 1px solid var(--catalog-border);
      border-radius: 8px;
      overflow: hidden;
      min-height: 34rem;
    }
  }

  .catalog-list-panel {
    background: var(--catalog-surface);
    border: 1px solid var(--catalog-border);
    border-radius: 8px;
    overflow: hidden;

    @media only screen and (min-width: ${screenSizes.laptop}) {
      border: none;
      border-right: 1px solid var(--catalog-border);
      border-radius: 0;
      max-height: 70vh;
      overflow-y: auto;
    }

    &.is-hidden-mobile {
      @media only screen and (max-width: 1023px) {
        display: none;
      }
    }
  }

  .catalog-jobs-legend {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    width: 100%;
    margin: 0 0 0.65rem;
    padding: 0.45rem 0.65rem;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: var(--catalog-muted);
    font-size: 0.78rem;
    line-height: 1.35;
    text-align: left;

    &__label,
    &__toggle {
      display: flex;
      align-items: center;
      gap: 0.45rem;
      min-width: 0;
      text-align: left;
    }

    &__toggle {
      flex: 1;
      margin: 0;
      padding: 0;
      border: none;
      background: transparent;
      color: inherit;
      font: inherit;
      cursor: pointer;
    }

    &__clear {
      flex: 0 0 auto;
      margin: 0 0 0 auto;
      padding: 0;
      border: none;
      background: transparent;
      color: inherit;
      font: inherit;
      font-weight: 650;
      text-decoration: underline;
      text-underline-offset: 2px;
      white-space: nowrap;
      cursor: pointer;
    }

    &__dot {
      flex: 0 0 auto;
      width: 0.55rem;
      height: 0.55rem;
      border-radius: 50%;
      background: #0a66c2;
    }

    &.is-active {
      background: #e8f3fc;
      color: #0a66c2;
      font-weight: 650;
    }
  }

  .catalog-pager {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    margin: 0.85rem 0 0;
    padding: 0.15rem 0.25rem 0;

    button {
      min-width: 2rem;
      height: 2rem;
      margin: 0;
      padding: 0 0.55rem;
      border: 1px solid var(--catalog-border);
      border-radius: 6px;
      background: var(--catalog-surface);
      color: var(--catalog-text);
      font-size: 0.8rem;
      line-height: 1;
      cursor: pointer;

      &:hover:not(:disabled) {
        background: #f3f2ef;
      }

      &:disabled {
        opacity: 0.4;
        cursor: default;
      }

      &.is-current {
        background: #e8f3fc;
        border-color: #d6e6f5;
        color: #0a66c2;
        font-weight: 650;
      }
    }
  }

  .catalog-list-panel > .catalog-pager {
    margin: 0;
    padding: 0.65rem 1rem;
    border-top: 1px solid #f0f0f0;
    position: sticky;
    bottom: 0;
    z-index: 1;
    background: var(--catalog-surface);
  }

  .catalog-list-panel > .catalog-jobs-legend {
    margin: 0;
    padding: 0.65rem 1rem;
    border-radius: 0;
    border-bottom: 1px solid #f0f0f0;
    position: sticky;
    top: 0;
    z-index: 1;
    background: var(--catalog-surface);

    &.is-active {
      background: #e8f3fc;
      border-bottom-color: #d6e6f5;
    }
  }

  .catalog-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .catalog-detail-panel {
    background: var(--catalog-surface);
    border: 1px solid var(--catalog-border);
    border-radius: 8px;
    min-height: 24rem;

    @media only screen and (min-width: ${screenSizes.laptop}) {
      border: none;
      border-radius: 0;
      min-height: 34rem;
      max-height: 70vh;
      overflow-y: auto;
    }

    &.is-hidden-mobile {
      @media only screen and (max-width: 1023px) {
        display: none;
      }
    }
  }

  .catalog-empty,
  .catalog-loading,
  .catalog-placeholder {
    margin: 0;
    padding: 2.5rem 1.25rem;
    text-align: center;
    color: var(--catalog-muted);
    font-size: 0.95rem;
    line-height: 1.5;
  }

  .catalog-empty--page,
  .catalog-loading--page {
    background: var(--catalog-surface);
    border: 1px solid var(--catalog-border);
    border-radius: 8px;
  }
`;

export const NetworkDirectoryCard = styled.button`
  position: relative;
  width: 100%;
  display: flex;
  gap: 0.85rem;
  align-items: flex-start;
  padding: 0.9rem 1rem;
  margin: 0;
  background: #ffffff;
  border: none;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 0;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.12s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f9f9f9;
  }

  &.is-selected {
    background: #eef3f8;
  }

  &.has-jobs {
    padding-right: 1.75rem;
  }

  .directory-card__jobs {
    position: absolute;
    top: 0.95rem;
    right: 0.85rem;
    width: 0.55rem;
    height: 0.55rem;
    border-radius: 50%;
    background: #0a66c2;
  }

  &:focus-visible {
    outline: 2px solid #0a66c2;
    outline-offset: -2px;
  }

  .directory-card__category {
    margin: 0 0 0.15rem;
    color: #666666;
    font-size: 0.68rem;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .directory-card__avatar {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    background: #f3f2ef;
    color: #191919;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.95rem;
    font-weight: 650;
    letter-spacing: 0.02em;
    text-transform: uppercase;

    &.has-photo {
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }

  .directory-card__content {
    min-width: 0;
    flex: 1;
  }

  .directory-card__name {
    margin: 0;
    font-size: 0.98rem;
    font-weight: 650;
    line-height: 1.3;
    color: #191919;
    word-break: break-word;
  }

  .directory-card__service {
    margin: 0.2rem 0 0;
    color: #666666;
    font-size: 0.85rem;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .directory-card__meta {
    margin: 0.35rem 0 0;
    color: #666666;
    font-size: 0.78rem;
    line-height: 1.35;
  }
`;

export const NetworkDirectoryPanel = styled.div`
  position: relative;
  padding: 1.25rem 1.25rem 1.5rem;

  @media only screen and (min-width: ${screenSizes.tablet}) {
    padding: 1.5rem 1.75rem 1.75rem;
  }

  .directory-panel__toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    margin: -1.25rem -1.25rem 1.15rem;
    padding: 0.65rem 0.85rem;
    border-bottom: 1px solid #e0e0e0;

    @media only screen and (min-width: ${screenSizes.tablet}) {
      margin: -1.5rem -1.75rem 1.25rem;
      padding: 0.7rem 1rem;
    }
  }

  .directory-panel__close {
    flex: 0 0 auto;
    width: 2rem;
    height: 2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 0 auto;
    padding: 0;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background: #f3f2ef;
    color: #666666;
    cursor: pointer;

    i.icon {
      margin: 0;
    }

    &:hover {
      background: #e8e6e1;
      color: #191919;
    }
  }

  .directory-panel__back {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
    color: #0a66c2;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
  }

  .directory-panel__header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.9rem;
    margin: 0 0 1.35rem;
  }

  .directory-panel__title-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
  }

  .directory-panel__jobs-cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    margin: 0;
    padding: 0.4rem 0.85rem;
    border: none;
    border-radius: 24px;
    background: #0a66c2;
    color: #fff;
    font-size: 0.8rem;
    font-weight: 650;
    line-height: 1.2;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      background: #004182;
    }
  }

  .directory-panel__job-title {
    margin: 0 0 0.4rem;
    color: #191919;
    font-size: 1.05rem;
    font-weight: 650;
    line-height: 1.3;
  }

  .directory-panel__identity {
    min-width: 0;
    flex: 1;
    padding-top: 0.1rem;
  }

  .directory-panel__eyebrow {
    margin: 0 0 0.3rem;
    color: #666666;
    font-size: 0.8125rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .directory-panel__title {
    margin: 0;
    flex: 1;
    min-width: 0;
    font-size: 1.35rem;
    font-weight: 650;
    color: #191919;
    line-height: 1.3;
    word-break: break-word;
  }

  .directory-panel__section {
    margin: 0 0 1.1rem;
    padding-bottom: 1.1rem;
    border-bottom: 1px solid #e0e0e0;

    &:last-of-type {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }

  .directory-panel__label {
    margin: 0 0 0.35rem;
    font-size: 0.8125rem;
    font-weight: 650;
    color: #191919;
  }

  .directory-panel__logo {
    display: block;
    width: 4.75rem;
    height: 4.75rem;
    object-fit: cover;
    border-radius: 12px;
    border: 1px solid #e0e0e0;
    background: #f3f2ef;
    flex-shrink: 0;

    @media only screen and (min-width: ${screenSizes.tablet}) {
      width: 5.5rem;
      height: 5.5rem;
    }
  }

  .directory-panel__gallery {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
    gap: 0.6rem;

    button {
      display: block;
      width: 100%;
      margin: 0;
      padding: 0;
      border: none;
      background: transparent;
      cursor: zoom-in;
      border-radius: 8px;

      &:focus-visible {
        outline: 2px solid #0a66c2;
        outline-offset: 2px;
      }
    }

    img {
      display: block;
      width: 100%;
      aspect-ratio: 1;
      object-fit: cover;
      border-radius: 8px;
      border: 1px solid #e0e0e0;
      background: #f3f2ef;
    }
  }

  .directory-panel__text {
    margin: 0;
    color: #434343;
    font-size: 0.95rem;
    line-height: 1.5;
    white-space: pre-wrap;
  }

  .directory-panel__list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 0.55rem;
  }

  .directory-panel__item {
    display: flex;
    gap: 0.55rem;
    align-items: flex-start;
    color: #434343;
    font-size: 0.95rem;
    line-height: 1.4;

    i.icon {
      margin: 0.15rem 0 0;
      color: #666666;
    }

    a {
      color: #0a66c2;
      word-break: break-all;
    }
  }
`;

/** @deprecated Use NetworkDirectoryPanel */
export const NetworkDirectoryModal = NetworkDirectoryPanel;
